export default "__VITE_ASSET__Cwjwt77L__"